import React, { Fragment } from "react";

import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";
import Context from "../components/Context/Context";
import Teo from "../components/Text-Teorio/teo";
import CardImg from "../components/Card-Img-section/CardImg";
import Schedule from "../components/Schedule/Schedule";
import WikiContextTeo from "../components/WikiContext/WikiContextTeo";
import TeorioContext from "../components/Full-Teorio/TeorioContext";

const WikiContext = () => {
  return (
    <Fragment>
      <Header />
      <Schedule />
      <Context />
      <CardImg />
      <Teo />
      <WikiContextTeo />
      <TeorioContext />
      <Footer />
    </Fragment>
  );
};

export default WikiContext;
